import type { NodeContent } from '~/interfaces/page';

import NodeRenderer from '../NodeRenderer';

export const serializeNode = (node: NodeContent | NodeContent[], rootClassName?: string) => {
  if (!node) {
    return null;
  }

  if (Array.isArray(node)) {
    return node.map((node: NodeContent, index: number) => (
      <NodeRenderer key={index} node={node} rootClassName={rootClassName}>
        {node.content ? serializeNode(node.content as NodeContent[]) : null}
      </NodeRenderer>
    ));
  }

  return (
    <NodeRenderer node={node} rootClassName={rootClassName}>
      {node.content ? serializeNode(node.content as NodeContent[]) : null}
    </NodeRenderer>
  );
};
